<template>
  <div class="emat-field-wrapper">
    <div class="emat-select-container">
      <div class="chevron">
        <img :src="getIcon('triangle.svg')" alt="chevron" />
      </div>
      <label :class="{ active: value }" class="emat-label">
        {{ label }}
      </label>
      <select
        class="emat-select"
        :class="{ active: value, 'has-error': error }"
        :value="value"
        @change="$emit('input', $event.target.value)"
      >
        <option
          v-for="option in availableOptions"
          :key="option"
          :value="option"
          :disabled="option === 'Selecteer een optie'"
        >
          {{ option }}
        </option>
      </select>
    </div>
    <small v-if="error" class="error">{{ error.message }}</small>
  </div>
</template>

<script>
export default {
  name: 'EmatSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    hasDefaultOption: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
      required: false,
    },
  },
  computed: {
    availableOptions() {
      const defaultOption = ['Selecteer een optie'];

      return this.hasDefaultOption
        ? [...defaultOption, ...this.options]
        : this.options;
    },
  },
};
</script>
